import {RecurringPaymentStatus, StudentRecurringPayment} from "types/student-account/student-payment"

export const hasActiveRecurringPaymentForPlan = (
    recurringPayments: StudentRecurringPayment[],
    paymentPlanId?: number | null
): boolean => {
    if (!paymentPlanId) return false
    return recurringPayments.some(
        (payment) =>
            payment.status === RecurringPaymentStatus.Active &&
            payment.paymentPlanItems?.some((item) => item.paymentPlanId === paymentPlanId)
    )
}
